<div class="bp-toolbar">
  <div class="field" *ngIf="!loading() && (partners()?.length || 0) > 0">
    <label class="field-label" for="bpLevelSelect">{{ 'business_partners.level_filter' | translate }}</label>
    <div class="level" (click)="$event.stopPropagation()">
      <button class="level-trigger" type="button" (click)="toggleLevelOpen($event)">
        {{ selectedLevel() === 'ALL' ? ('business_partners.level_all' | translate) : selectedLevel() }}
      </button>
      <div class="level-panel" *ngIf="openLevel">
        <div class="level-item" [class.active]="selectedLevel() === 'ALL'" (click)="onSelectLevel('ALL', $event)">{{ 'business_partners.level_all' | translate }}</div>
        <div class="level-item" *ngFor="let lvl of (levels() || [])" [class.active]="selectedLevel() === lvl" (click)="onSelectLevel(lvl, $event)">{{ lvl }}</div>
      </div>
    </div>
  </div>
  <label class="checkbox" *ngIf="!loading() && (partners()?.length || 0) > 0">
    <input type="checkbox" [checked]="showDisabled()" (change)="showDisabled.set($any($event.target).checked)" />
    <span>{{ 'business_partners.show_disabled' | translate }}</span>
  </label>
  <button class="button primary" type="button" (click)="openAddDialog()">
    <span class="material-symbols-outlined">add</span>
    {{ 'business_partners.add_new_business_partner' | translate }}
  </button>
</div>

<ng-container *ngIf="loading(); else loadedTpl">{{ 'business_partners.loading_business_partners' | translate }}</ng-container>

<ng-template #loadedTpl>
  <ng-container *ngIf="!error(); else errorTpl">
    <ng-container *ngIf="(partners()?.length || 0) === 0; else partnersGrid">
      <div class="empty">{{ 'business_partners.empty_state' | translate }}</div>
    </ng-container>
    <ng-template #partnersGrid>
      <div class="bp-grid">
        <app-business-partner-card *ngFor="let p of (filteredPartners() || [])" [partner]="p" (updated)="onPartnerUpdated()" />
      </div>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #errorTpl>
  <div class="error">{{ error() }}</div>
</ng-template>

<app-add-business-partner-dialog *ngIf="showAddDialog()"
  [submitting]="submitting()"
  (closed)="closeAddDialog()"
  (submitPartner)="submitNewPartner($event)" />
